import { AppErrorMajor } from 'src/app/core/app-error/app-error-major.enum';

export const errorPageFallbackTexts = {
  key: AppErrorMajor.CarlNotAvailable,
  headline: 'Mercedes-Benz Car Configurator not available',
  description: `We're sorry. The car configurator is currently not available for technical reasons. Please try again later.`,
  primaryAction: 'Go to home page'
};
